import { head, last, split, upperCase } from "lodash";

export const USER_SIGN_UP_MODES = {
  WEB_APP: "web",
  APP: "app",
};

export const convertToDecimalNumber = (n, decimal) => {
  if (typeof n === "string") return;
  return parseFloat(n.toFixed(decimal));
};

export const getUserNameInitials = (name) => {
  const breakName = name?.split(" ")
  const firstName = breakName?.[0];
  const secondName = breakName?.[1] || undefined;
  if(secondName){
    return `${head(split(upperCase(firstName), ''))}${head(split(upperCase(secondName), ''))}`;
  }else{
    return `${head(split(upperCase(firstName), ''))}` 
  }
};

export const downloadUrl = (url, filename) => {
  fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
};

export const generateHash = (str) => {
  let hash = 0,
    i,
    chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash);
};

export const getUploadProgress = (progressEvent) => {
  const { loaded, total } = progressEvent;
  let percent = Math.floor((loaded * 100) / total);
  if (percent < 100) {
    return percent;
  }
  return 100;
};

export const readFile = (file) => {
  let reader = new FileReader();
  reader.readAsArrayBuffer(file);
  return (reader.onload = function (e) {
    let arr = new Uint8Array(reader.result);
    return arr;
  })();
};

export const createFile = (file) => {
  let FILE = new File([file.arrayBuffer()], file.name, file);
  return FILE;
};
export const serialize = (data) => {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
};

export const generateUUID = () => Date.now();

export const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export function getFileArrayBuffer(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = function() {
      if (reader.result) {
        resolve(reader.result);
      } else {
        reject(new Error('Failed to read the file.'));
      }
    };

    reader.onerror = function() {
      reject(new Error('Error occurred while reading the file.'));
    };

    reader.readAsArrayBuffer(file);
  });
}

export function decodeBase64ToBlob(base64String) {
  const parts = base64String.split(';base64,');
  const contentType = parts[0].split(':')[1];
  const raw = window.atob(parts[1]);
  const rawLength = raw.length;
  const uInt8Array = new Uint8Array(rawLength);

  for (let i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }
  return new Blob([uInt8Array], { type: contentType });
};

export function removeExtension (acceptedFile){
  const fileNameWithExtension = acceptedFile || 'batch';
  const fileName = fileNameWithExtension.substring(0, fileNameWithExtension.lastIndexOf('.')) || fileNameWithExtension ;
  return fileName;
}

export function localConvertToCSV(folderList) {
  let csvBody = '';
  let maxImage = 0;

  sessionStorage.setItem('batchCSVData', JSON.stringify(folderList));
  
  folderList.forEach((folder, index) => {
    let Width = folder.width;
    let Height = folder.height;
    let ProductPosition = folder.position;
    let currentCol = `${folder.skuId || ''},${folder.skuId || ''},${Height},${Width},${ProductPosition},`;//For csv we use sku_id as the joblabel
    let currImageNo = 0;

    folder.imageUrls.forEach(image => {
      currentCol += `${image.dataURL || ''},`;
      currImageNo++;
    });

    maxImage = Math.max(maxImage, currImageNo);
    currentCol += `\n`;
    csvBody += currentCol;
  });

  let csvHeader = 'SKU ID,Project Name,Height (px),Width (px),Product Position';
  for (let i = 1; i <= maxImage; i++) {
    csvHeader += `,Image ${i}`;
  }
  csvHeader += '\n';

  return csvHeader + csvBody;
}


export const needToRemoveBG = async (base64Image) => {
  const TRANSPARENCY_TRANSLUCENCY_LIMIT = process.env.NEXT_PUBLIC_TRANSPARENCY_TRANSLUCENCY_LIMIT || 20;

  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;
    img.crossOrigin = "Anonymous";

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, img.width, img.height).data;

      let transparentCount = 0;
      let translucentCount = 0;
      let opaqueCount = 0;

      const totalPixels = imageData.length / 4;

      for (let i = 0; i < imageData.length; i += 4) {
        const alpha = imageData[i + 3];

        if (alpha === 0) {
          transparentCount++;
        } else if (alpha === 255) {
          opaqueCount++;
        } else {
          translucentCount++;
        }
      }

      const transparentPercentage = (transparentCount / totalPixels) * 100;
      const translucentPercentage = (translucentCount / totalPixels) * 100;

      console.log(`Transparent Pixels: ${transparentCount}`);
      console.log(`Translucent Pixels: ${translucentCount}`);
      console.log(`Opaque Pixels: ${opaqueCount}`);
      console.log(`Total Pixels: ${totalPixels}`);
      console.log(`transparentPercentage: ${transparentPercentage}`);
      console.log(`translucentPercentage: ${translucentPercentage}`);

      resolve(
        transparentPercentage + translucentPercentage <=
          TRANSPARENCY_TRANSLUCENCY_LIMIT
      );
    };

    img.onerror = (err) => {
      console.error("Image failed to load", err);
      reject(false); // Reject as `false` if image loading fails
    };
  });
};
